import { Redirect, Stack } from 'expo-router';
import { observer } from '@legendapp/state/react';
import { globalState } from '@/state/globalState';
import { canAccessChecklistDashboard } from '@/utils/userRoles';
import { ActivityIndicator, View } from 'react-native';

function AdminLayout() {
  const profile = globalState.user.profile.get();
  const appReady = globalState.app.isReady.get();

  if (!appReady || !profile) {
    return <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <ActivityIndicator accessibilityLabel="Carregando painel" />
    </View>;
  }

  if (!canAccessChecklistDashboard(profile.user_type)) {
    return <Redirect href="/(app)" />;
  }

  return (
    <Stack initialRouteName="dashboard">
      <Stack.Screen name="dashboard" options={{ headerShown: false }} />
    </Stack>
  );
}

export default observer(AdminLayout);
